import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Logo } from '@/components/Logo';

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-paper">
      <header className="px-4 pt-8 sm:px-8">
        <Link to="/" aria-label="MyDash" className="inline-block rounded-control">
          <Logo className="h-8" />
        </Link>
      </header>
      <main className="flex flex-1 items-start justify-center px-4 py-10 sm:items-center">
        <div className="w-full max-w-[400px]">
          <h1 className="text-[28px] font-bold tracking-[-0.03em] text-ink">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-muted-ink">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-center text-sm text-muted-ink">{footer}</div>}
        </div>
      </main>
      <footer className="px-4 pb-6 text-center text-xs text-muted-ink">Every number that matters. One clean dashboard.</footer>
    </div>
  );
}

export const linkClass = 'font-medium text-ink underline underline-offset-4';
